import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mapings = new Map<ProfiBazaAPIModels.ChannelKind, string>([
	[ProfiBazaAPIModels.ChannelKind.Form, 'Formularz'],
	[ProfiBazaAPIModels.ChannelKind.ExternalSystem, 'System zewnętrzny'],
]);

export const map = (value: ProfiBazaAPIModels.ChannelKind): string =>
	mapings.get(value) ?? '';
